const React = require('react');
const formatTime = require('mn-utils/formatTime');
const withReDelay = require('mn-utils/withReDelay');
const viewport$ = require('mn-utils/browser/emitters/viewport');

const {apiV2ReferralOrdersList} = require('../../../../../../api/referral/transaction');

const {IntervalFilterReferral, initFilter} = require('../../../../../dumb/IntervalFilterCustom');
const IntervalFilter = require('../../../../../dumb/IntervalFilter');
const ReportDownload = require('../../../../../dumb/ReportDownload/ReferralRD');
const RefCell = require('../../../../../dumb/TableHeadCell/RefCell');

const TableItem = require('./components/TableItem');
const Ripple = require("../../../../../dumb/Ripple");
const {default: RefreshIcon} = require("@material-ui/icons/Refresh");

const {
  getRFC3339,
} = formatTime;
const {
  getDateRange,
} = IntervalFilter;

const filter$ = initFilter();

const getParams = (filter) => {
  const {
    from,
    to,
  } = getDateRange(filter);

  return {
    search: filter.search || null,
    from: from ? Math.floor(from / 1000) : null,
    to: to ? Math.floor(to / 1000) : null
  };
};

module.exports = require('../../../../../../utils/virtualOutputComponentProvider')({
  state: {
    filter: filter$,
    viewport: viewport$.throttle(100),
  },
  rowHeight: 60,
  nodata: (<div
    className="f16 fw4 cC mt20 ttU tc w"
  >No data</div>),
  request: apiV2ReferralOrdersList,
  getParams: (self) => getParams(self.state.filter),
  wrapper(render, setState, self) {
    const update = withReDelay(self.update, 1000);
    function handleChangeFilter(filter) {
      filter$.emit({
        ...self.state.filter,
        ...filter,
      });
      update();
    }
    return (state) => {
      const filter = state.filter;
      const noData = !state.data || !state.data.count;

      return (
        <div>
           <div className="h48 layoutRow jcFE aiC">
            {!noData && (
              <ReportDownload
                className="pl10"
                urlPrefix="/v2/referral-api/partner/merchant-statistic/report/"
                filter={filter}
                disabled={noData}
              />
            )}
            <div className="ml40">
             <Ripple
               className="w162 h45 layoutRow jcC aiC ttU f12 bg3E4044 cF r9"
               onClick={self.update}
             >
               <div className="pr10">Refresh</div>
               <RefreshIcon className="w20" />
             </Ripple>
            </div>
           </div>
          <IntervalFilterReferral
            className="mt24 mb25"
            data={filter}
            onChange={handleChangeFilter}
            search={{
              className: 'w310',
              placeholder: 'Search by Name / Email',
            }}
          />
          <div className="h100vh-450 rlv">
            <div className="abs sh sb10 st0 ov">
              <div className="abs s ovxA">
                <div className="w rlv h">
                  <div className="w abs bgE layoutRow fhaS fvaC r9 ov w1/4>1">
                    <RefCell>Merchant Name</RefCell>
                    <RefCell>Transaction Count</RefCell>
                    <RefCell>Transaction Amount</RefCell>
                    <RefCell>Total Commission</RefCell>
                  </div>
                  <div className="abs sh st45 sb c0>.CircularProgress">
                    {render(TableItem)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };
  },
});
